import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseTextSource } from "./BaseTextSource.js";
/**
 * @memberOf Qualifiers.Source
 * @extends {Qualifiers.Source.SubtitlesSource}
 * @description Defines how to manipulate a Subtitles layer
 */

var SubtitlesSource = /*#__PURE__*/function (_BaseTextSource) {
  _inherits(SubtitlesSource, _BaseTextSource);

  var _super = _createSuper(SubtitlesSource);

  function SubtitlesSource(fileName) {
    var _this;

    _classCallCheck(this, SubtitlesSource);

    _this = _super.call(this, fileName);
    _this.type = 'subtitles'; // used within TextSource for l/u_subtitles:

    _this._qualifierModel = {
      sourceType: 'subtitles',
      publicId: fileName
    };
    return _this;
  }
  /**
   * @description Set the textStyle for the subtitles layer
   * @param {TextStyle} textStyle
   */


  _createClass(SubtitlesSource, [{
    key: "textStyle",
    value: function textStyle(_textStyle) {
      this._textStyle = _textStyle;
      this._qualifierModel.textStyle = _textStyle.toJson();
      return this;
    }
    /**
     *
     * @description Used within getOpenSourceString of TextSource, this function overwrites the default encoding behaviour
     * Subtitle file names require a different encoding than texts
     * @param text
     * @example
     * encodeText('foo/bar'); // -> foo:bar
     */

  }, {
    key: "encodeText",
    value: function encodeText(text) {
      return text.replace(/\//g, ':');
    }
  }]);

  return SubtitlesSource;
}(BaseTextSource);

export { SubtitlesSource };